export default {"src":"/_next/static/media/puzzle.a23f362d.svg","height":175,"width":378,"blurWidth":0,"blurHeight":0};